import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import "../../../css/Menu.scss";
import MenuMap from '../../../images/icon-map.svg';
import MenuCalender from '../../../images/icon-cal.svg';
import MenuInfinity from '../../../images/icon-icommons.svg';
import MenuSpeaker from '../../../images/icon-speaker.svg';
import MenuNews from '../../../images/icon-news.svg';
import MenuYoutube from '../../../images/icon-youtube.svg';
import MenuX from '../../../images/icon-x.svg';
import MenuInstagram from "../.././../images/icon-instagram.svg";
import { useAtom } from 'jotai';
import { currentMenuNumAtom } from '../../atoms/currentMenuState';
import universityData from "../../../json/university_data.json";

const MotionBox = motion(Box);

const Menu = () => {
    const [currentMenuNum, setCurrentMenuNum] = useAtom(currentMenuNumAtom);

    const changeMenu = (menuNum) => {
        setCurrentMenuNum(menuNum);
    };

    return (

        <div className="App-right-bar">
            <div id="Menu_outer">
                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 0 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 0 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(0)}
                    className="Menu_tab"
                    id="Tab_campus_map"
                >
                    <img className="Menu_icon" alt="campusMap" src={MenuMap} />
                    <div className="Menu_title">CAMPUS MAP</div>
                </MotionBox>

                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 1 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 1 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(1)}
                    className="Menu_tab"
                    id="Tab_event_calendar"
                >
                    <img className="Menu_icon" alt="event" src={MenuCalender} />
                    <div className="Menu_title">イベントカレンダー</div>
                </MotionBox>

                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 2 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 2 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(2)}
                    className="Menu_tab"
                    id="Tab_university_news"
                >
                    <img className="Menu_icon" alt="news" src={MenuNews} />
                    <div className="Menu_title">{universityData.university.name}News</div>
                </MotionBox>

                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 3 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 3 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(3)}
                    className="Menu_tab"
                    id="Tab_instagram"
                >
                    <img className="Menu_icon" alt="instagram" src={MenuInstagram} />
                    <div className="Menu_title">{universityData.university.name}<br />公式Instagram</div>
                </MotionBox>

                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 4 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 4 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(4)}
                    className="Menu_tab"
                    id="Tab_twitter"
                >
                    <img className="Menu_icon" alt="twitter" src={MenuX} />
                    <div className="Menu_title">{universityData.university.name}<br />公式X</div>
                </MotionBox>

                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 5 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 5 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(5)}
                    className="Menu_tab"
                    id="Tab_youtube"
                >
                    <img className="Menu_icon" alt="youtube" src={MenuYoutube} />
                    <div className="Menu_title">{universityData.university.name}<br />公式YouTube</div>
                </MotionBox>

                <MotionBox
                    style={{
                        transform: `translate3d(${currentMenuNum === 6 ? 0 : 40}px, 0, 0)`,
                        WebkitTransform: `translate3d(${currentMenuNum === 6 ? 0 : 40}px, 0, 0)`,
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    onClick={() => changeMenu(6)}
                    className="Menu_tab"
                    id="Tab_konan_infinity"
                >
                    <img className="Menu_icon" alt="infinity" src={MenuInfinity} />
                    <div className="Menu_title">施設利用状況</div>
                </MotionBox>
            </div>
        </div>
    );
};

export default Menu;
